import axios from '@/lib/axios';
import { SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1251. 受注案件アーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const unarchiveSalesOrder = (props: Props): Promise<SalesOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/unarchive`, props);
};

export const useUnarchiveSalesOrder = () => {
  return useMutation({
    mutationFn: unarchiveSalesOrder,
  });
};
